<template>
  <component :is="type" :class="['button-group']"><slot /></component>
</template>
<script>
/**
 * ButtonGroups are a series of buttons together on a single line
 */
export default {
  name: "ButtonGroup",
  status: "prototype",
  release: "3.5.0",
  props: {
    /**
     * The html element used for the ButtonGroup
     */
    type: {
      type: String,
      default: "div",
    },
  },
};
</script>

<style lang="scss" scoped>
.button-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  > .button {
    font-weight: 400;
    margin: 0;
    position: relative;
    flex: 0 1 auto;
    &:hover,
    &.hover {
      z-index: 1;
      transform: translateZ(0) scale(1);
    }
    &:focus,
    &:active,
    &.active {
      z-index: 1;
      transform: translateZ(0) scale(1);
    }
  }

  &__title {
    @include reset;
    @include stack-space($space-s);
    @include inline-space($space-xs);
    flex: 0 1 auto;
    font-size: $size-s;
    font-family: $font-text;
    line-height: $line-height-s;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    height: auto;
    align-self: stretch;
    padding: 0 $space-m;
    border-radius: 6px;
    margin: 0;
    border: 1px solid $border-color;
    font-weight: $weight-semi-bold;
  }

  .button + .button,
  .button + .button-group,
  .button-group + .button,
  .button-group + .button-group {
    // margin-left: -1px;
    border-left: 0;
  }
}

// Optional: Group multiple button groups together for a toolbar
.button-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .input-group {
    width: auto;
  }
}

.button-group {
  > .button:first-child {
    margin-left: 0;
  }
  // Reset rounded corners
  > .button:not(:last-child):not(.dropdown-toggle),
  > .button-group__title,
  > .button-group:not(:last-child) > .button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  > .button:not(:first-child),
  > .button-group:not(:first-child) > .button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
